import React, { useEffect, useState } from "react";
import { apiFetch } from "../utils/api";
import { subirArchivo } from "../utils/upload";
import ImagenProtegida from "../components/ImagenProtegida";
import Cargando from "../components/Cargando";
import { Ayuda } from "../context/AyudaContext";

const CAMPOS_IMAGEN = [
  { clave: "archivo_encabezado", etiqueta: "Imagen de encabezado (membrete)" },
  { clave: "archivo_pie", etiqueta: "Imagen de pie de página" },
  { clave: "archivo_logo", etiqueta: "Logo pequeño (solo se usa si no hay encabezado)" },
];

function ConfigurarFirma() {
  const [datos, setDatos] = useState({
    nombre_encargado: "",
    correo_encargado: "",
    area_encargado: "",
    cargo_encargado: "",
    nombre_autorizado: "",
  });
  const [archivos, setArchivos] = useState({});
  const [subiendo, setSubiendo] = useState({});
  const [guardando, setGuardando] = useState(false);
  const [cargando, setCargando] = useState(true);
  const [mensaje, setMensaje] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    apiFetch("/api/configuracion-firma")
      .then((data) => {
        setDatos({
          nombre_encargado: data?.nombre_encargado || "",
          correo_encargado: data?.correo_encargado || "",
          area_encargado: data?.area_encargado || "",
          cargo_encargado: data?.cargo_encargado || "",
          nombre_autorizado: data?.nombre_autorizado || "",
        });
        setArchivos({
          archivo_encabezado: data?.archivo_encabezado || "",
          archivo_pie: data?.archivo_pie || "",
          archivo_logo: data?.archivo_logo || "",
          archivo_firma: data?.archivo_firma || "",
          archivo_firma_autorizado: data?.archivo_firma_autorizado || "",
        });
      })
      .catch((err) => setError(err.message))
      .finally(() => setCargando(false));
  }, []);

  const actualizarDato = (campo, valor) => setDatos((prev) => ({ ...prev, [campo]: valor }));

  const subir = async (clave, file) => {
    if (!file) return;
    setSubiendo((prev) => ({ ...prev, [clave]: true }));
    setError("");
    try {
      const nombreArchivo = await subirArchivo(file);
      setArchivos((prev) => ({ ...prev, [clave]: nombreArchivo }));
    } catch (err) {
      setError(err.message);
    } finally {
      setSubiendo((prev) => ({ ...prev, [clave]: false }));
    }
  };

  const guardar = async (e) => {
    e.preventDefault();
    setError("");
    setMensaje("");
    setGuardando(true);
    try {
      const respuesta = await apiFetch("/api/configuracion-firma", {
        method: "POST",
        body: JSON.stringify({ ...datos, ...archivos }),
      });
      // El servidor devuelve lo que quedó guardado: si no coincide con lo que
      // se envió, el guardado no tomó los cambios y no se debe decir "listo".
      const guardado = respuesta?.guardado;
      if (!guardado) {
        throw new Error("El servidor no confirmó el guardado. Recarga la página e inténtalo de nuevo.");
      }
      const distintos = Object.keys(archivos).filter((k) => (archivos[k] || null) !== (guardado[k] || null));
      if (distintos.length > 0) {
        throw new Error(
          `No se guardaron estas imágenes: ${distintos.join(", ")}. Avisa a soporte (el servidor las dejó con otro valor).`
        );
      }
      setMensaje("Guardado correctamente.");
    } catch (err) {
      setError(err.message);
    } finally {
      setGuardando(false);
    }
  };

  const vistaPrevia = (clave, etiqueta) => (
    <div key={clave} style={{ marginBottom: "1.2rem" }}>
      <label style={styles.campo}>
        {etiqueta}
        <input type="file" accept=".jpg,.jpeg,.png" onChange={(e) => subir(clave, e.target.files[0])} />
      </label>
      {subiendo[clave] && <p style={{ fontSize: "0.85rem" }}>Subiendo...</p>}
      {archivos[clave] && (
        <ImagenProtegida
          archivo={archivos[clave]}
          alt={etiqueta}
          style={{
            maxWidth: 280,
            maxHeight: 120,
            border: "1px solid #d3d9df",
            borderRadius: 6,
            padding: "0.5rem",
            marginTop: "0.5rem",
            display: "block",
          }}
        />
      )}
    </div>
  );

  if (cargando) return <Cargando />;

  return (
    <div style={{ maxWidth: 520, margin: "0 auto" }}>
      <h2>Datos de las Actas de Entrega</h2>
      <Ayuda>
      <p style={{ fontSize: "0.85rem", color: "#5b6472", textAlign: "center" }}>
        Estos datos se usan automáticamente en cada acta que se genere. Solo hay que
        configurarlos una vez.
      </p>
      </Ayuda>

      <form onSubmit={guardar}>
        {CAMPOS_IMAGEN.map((c) => vistaPrevia(c.clave, c.etiqueta))}

        <h3 style={{ marginTop: "1.5rem", textAlign: "center" }}>Quien entrega (Compras)</h3>
        <div className="form-grid" style={styles.grid}>
          <label style={styles.campo}>
            Nombre
            <input
              type="text"
              value={datos.nombre_encargado}
              onChange={(e) => actualizarDato("nombre_encargado", e.target.value)}
              placeholder="Ej. María Pérez"
              style={styles.input}
            />
          </label>
          <label style={styles.campo}>
            Correo
            <input
              type="email"
              value={datos.correo_encargado}
              onChange={(e) => actualizarDato("correo_encargado", e.target.value)}
              style={styles.input}
            />
          </label>
          <label style={styles.campo}>
            Área
            <input
              type="text"
              value={datos.area_encargado}
              onChange={(e) => actualizarDato("area_encargado", e.target.value)}
              placeholder="Ej. Administración"
              style={styles.input}
            />
          </label>
          <label style={styles.campo}>
            Cargo
            <input
              type="text"
              value={datos.cargo_encargado}
              onChange={(e) => actualizarDato("cargo_encargado", e.target.value)}
              placeholder="Ej. Oficial de Compras"
              style={styles.input}
            />
          </label>
        </div>
        {vistaPrevia("archivo_firma", "Imagen de la firma de compras")}

        <h3 style={{ marginTop: "1.5rem", textAlign: "center" }}>Quien autoriza</h3>
        <label style={styles.campo}>
          Nombre
          <input
            type="text"
            value={datos.nombre_autorizado}
            onChange={(e) => actualizarDato("nombre_autorizado", e.target.value)}
            placeholder="Ej. Pablo Beteta"
            style={styles.input}
          />
        </label>
        {vistaPrevia("archivo_firma_autorizado", "Imagen de la firma de autorización")}

        {error && <p style={{ color: "#a3402f" }}>{error}</p>}
        {mensaje && <p style={{ color: "#2f7a54" }}>{mensaje}</p>}

        <div style={{ marginTop: "1rem" }}>
          <button type="submit" disabled={guardando}>
            Guardar
          </button>
        </div>
      </form>
    </div>
  );
}

const styles = {
  campo: { display: "flex", flexDirection: "column", gap: "0.3rem", fontSize: "0.85rem", fontWeight: 600 },
  input: { padding: "0.5rem", border: "1px solid #d3d9df", borderRadius: 6, fontFamily: "inherit" },
  grid: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.75rem", marginBottom: "0.75rem" },
};

export default ConfigurarFirma;
